import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/social-google-plus.svg';

export const IconSocialGooglePlus: IconComponent = props => <Icon {...props} src={src} />;
